import "core-js/modules/es6.object.define-property";
import _get from "lodash/get";

var _createReducer;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import track from "./track";
import { trackAuthComponentShow, trackAuthComponentSuccess, trackAuthModalClose, trackAuthModalShow, trackCarouselInteraction } from "../../actions";
import { Flow } from "../../constants";
import { getStandardYodleeParams } from "./track-utils";
export default createReducer((_createReducer = {}, _defineProperty(_createReducer, trackAuthComponentShow, function (state) {
  var trackingState = _get(state, 'identity.tracking', null);

  track('auth-component:shown', trackingState);
}), _defineProperty(_createReducer, trackAuthComponentSuccess, function (state) {
  var identity = _get(state, 'identity');

  var trackingState = _get(state, 'identity.tracking', null);

  var flow = _get(state, 'identity.tracking.trk.trk_flow');

  var data;

  if (flow === Flow.ACCOUNT_AGG) {
    data = getStandardYodleeParams(identity);
  }

  track('auth-component:success', trackingState, data);
}), _defineProperty(_createReducer, trackAuthModalShow, function (state) {
  var trackingState = _get(state, 'identity.tracking', null);

  track('auth-modal:shown', trackingState);
}), _defineProperty(_createReducer, trackAuthModalClose, function (state, _ref) {
  var closedBy = _ref.closedBy,
      currentStep = _ref.currentStep;

  var trackingState = _get(state, 'identity.tracking', null);

  var modalShownAt = _get(trackingState, 'modalShownAt');

  var data = {
    closedBy: closedBy,
    closedOnStep: currentStep
  };

  if (modalShownAt) {
    var now = new Date();
    data.timeModalShown = (now - modalShownAt) / 1000;
  }

  track('auth-modal:closed', trackingState, data);
}), _defineProperty(_createReducer, trackCarouselInteraction, function (state) {
  var trackingState = _get(state, 'identity.tracking', null);

  track('auth-modal:carousel_interaction', trackingState);
}), _createReducer));